//TODO:@ranul ADD COMMENTS
// add the angular component selectors as the type
export enum WIDGET_TYPES {
  COUNT = 'app-count-widget',
  LINE = 'app-line-chart',
  BAR = 'app-bar-chart',
  DONUT = 'app-donut-widget',
  STACKED = 'app-stacked-bar-widget',
  NUMBER_CARD = 'app-number-card-widget',
  GROUP_BAR = 'app-group-bar-chart',
}

export enum WIDGET_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum WIDGET_CATEGORIES {
  LOGS = 'LOGS',
  DRIVES = 'DRIVES',
  MODULES = 'MODULES',
  CONNECTED_APPS = 'CONNECTED_APPS',
  CONNECTIONS = 'CONNECTIONS',
  IDENTITIES = 'IDENTITIES',
  MESSAGES = 'MESSAGES',
  PROJECTS = 'PROJECTS',
  NOTICES = 'NOTICES',
  PERMISSIONS = 'PERMISSIONS',
  ROLES = 'ROLES',
  PRIVILEGES = 'PRIVILEGES',
  REFERENCES = 'REFERENCES',
  KNOWLEDGEBASE = 'KNOWLEDGEBASE',
  VACANCIES = 'VACANCIES',
  SUBMISSIONS = 'SUBMISSIONS',
  CONSULTATIONS = 'CONSULTATIONS',
  PROPOSALS = 'PROPOSALS',
  SUBSCRIBERS = 'SUBSCRIBERS',
  CUSTOMERS = 'CUSTOMERS',
  WORKSTATIONS = 'WORKSTATIONS',
  ARTICLES = 'ARTICLES',
  ENDPOINTS = 'ENDPOINTS',
  MAPPINGS = 'MAPPINGS',
  STORAGE = 'STORAGE',
  TEST = 'TEST',
  ACTIVITIES = 'ACTIVITIES',
  AGENTS = 'AGENTS',
  CLAIMS = 'CLAIMS',
  COVER_NOTES = 'COVER_NOTES',
  ENDORSEMENTS = 'ENDORSEMENTS',
  INVOICES = 'INVOICES',
  LEADS = 'LEADS',
  POLICIES = 'POLICIES', // this is for group bar chart test
  TICKETS = 'TICKETS',
}

export enum WIDGET_KEYS {
  CONNECTED_APPS_COUNT = 'CONNECTED_APPS_COUNT',
  NOTICES_TYPE_COUNT = 'NOTICES_TYPE_COUNT',
  KNOWLEDGEBASE_TYPE_COUNT = 'KNOWLEDGEBASE_TYPE_COUNT',
  ROLES_TYPE_COUNT = 'ROLES_TYPE_COUNT',
  REFERENCES_COUNT = 'REFERENCES_COUNT',
  PRIVILEGES_COUNT = 'PRIVILEGES_COUNT',
  MESSAGES_TYPE_COUNT = 'MESSAGES_TYPE_COUNT',
  PROJECTS_COUNT = 'PROJECTS_COUNT',
  IDENTITIES_TYPE_COUNT = 'IDENTITIES_TYPE_COUNT',
  NOTICES_COUNT = 'NOTICES_COUNT',
  DRIVES_COUNT = 'DRIVES_COUNT',
  MESSAGES_COUNT = 'MESSAGES_COUNT',
  ROLES_COUNT = 'ROLES_COUNT',
  PERMISSION_COUNT = 'PERMISSION_COUNT',
  IDENTITIES_COUNT = 'IDENTITIES_COUNT',
  MODULES_COUNT = 'MODULES_COUNT',
  TEST_APPS_COUNT = 'TEST_APPS_COUNT',
  IDENTITIES_UNVERIFIED_COUNT = 'IDENTITIES_UNVERIFIED_COUNT',
  IDENTITIES_VERIFIED_COUNT = 'IDENTITIES_VERIFIED_COUNT',
  LOGS_COUNT = 'LOGS_COUNT',
  NOTICES_REPORT = 'NOTICES_REPORT',
  VACANCIES_COUNT = 'VACANCIES_COUNT',
  VACANCIES_TYPE_COUNT = 'VACANCIES_TYPE_COUNT',
  SUBMISSIONS_COUNT = 'SUBMISSIONS_COUNT',
  SUBMISSIONS_TYPE_COUNT = 'SUBMISSIONS_TYPE_COUNT',
  SUBMISSIONS_POSITION_COUNT = 'SUBMISSIONS_POSITION_COUNT',
  SUBMISSIONS_MONTHS_COUNT = 'SUBMISSIONS_MONTHS_COUNT',
  CONSULTATIONS_COUNT = 'CONSULTATIONS_COUNT',
  CONSULTATIONS_TYPE_COUNT = 'CONSULTATIONS_TYPE_COUNT',
  CONSULTATIONS_REQUEST_TYPE_COUNT = 'CONSULTATIONS_REQUEST_TYPE_COUNT',
  CONSULTATIONS_PRODUCT_TYPE_COUNT = 'CONSULTATIONS_PRODUCT_TYPE_COUNT',
  CONSULTATIONS_SERVICES_TYPE_COUNT = 'CONSULTATIONS_SERVICES_TYPE_COUNT',
  PROPOSALS_COUNT = 'PROPOSALS_COUNT',
  PROPOSALS_TYPE_COUNT = 'PROPOSALS_TYPE_COUNT',
  WORKSTATIONS_BOOKING_COUNT = 'WORKSTATIONS_BOOKING_COUNT',
  WORKSTATIONS_STACKED_COUNT = 'WORKSTATIONS_STACKED_COUNT',
  SUBSCRIBERS_COUNT = 'SUBSCRIBERS_COUNT',
  WORKSTATIONS_OVERBOOKING_COUNT = 'WORKSTATIONS_OVERBOOKING_COUNT',
  QUOTA_SYSTEM = 'QUOTA_SYSTEM',
  QUOTA_CONNECTED_APPS = 'QUOTA_CONNECTED_APPS',
  ACTIVE_CUSTOMER_COUNT = 'ACTIVE_CUSTOMER_COUNT',
  DELETED_CUSTOMER_COUNT = 'INACTIVE_CUSTOMER_COUNT',
  OPEN_TICKETS = 'OPEN_TICKETS',
  ON_HOLD_TICKETS = 'ON_HOLD_TICKETS',
  RESOLVED_TICKETS = 'RESOLVED_TICKETS',
  CLOSED_TICKETS = 'CLOSED_TICKETS',
  ARTICLE_VIEWS_COUNT = 'ARTICLE_VIEWS_COUNT',
  ENDPOINTS_COUNTS = 'ENDPOINTS_COUNTS',
  MAPPINGS_COUNTS = 'MAPPINGS_COUNTS',
  USER_QUOTA = 'USER_QUOTA',
  TICKETS_TAT = 'TURN_AROUND_TIME',
  SUPPORT_TICKETS_COUNT = 'SUPPORT_TICKET_COUNT',
  SUPPORT_TICKET_DAILY_COUNT = 'SUPPORT_TICKET_DAILY_COUNT',
  SUPPORT_TICKET_STATUS_COUNT = ' SUPPORT_TICKET_STATUS_COUNT',
  DAILY_AVERAGE_TAT_BAR = 'DAILY_AVERAGE_TAT_BAR',
  WEEK_AVERAGE_TAT_COUNT = 'WEEK_AVERAGE_TAT_COUNT',
  CUMULATIVE_OPEN_TICKET = 'CUMULATIVE_OPEN_TICKET',
  CUMULATIVE_UNRESOLVED_TICKET = 'CUMULATIVE_UNRESOLVED_TICKET',
  UNRESOLVED_TODAY_TICKET = ' UNRESOLVED_TODAY_TICKET',
  TEST_GROUP_BAR = 'TEST_GROUP_BAR', // This is for group bar chart test
}
